module.exports = __webpack_public_path__ + "static/media/adventure.6cd42721.jpg";